import React, { useState } from "react";
import Carousel, { Modal, ModalGateway } from "react-images";
import {
  StyledDiv1,
  StyledDiv2,
  StyledDiv3,
  StyledDiv4,
  StyledDiv5,
} from "./style";
import ImageComponent from "../../Layout/LoggedInLayout/ImageComponent";

const Item = ({ item }) => {
  const [modalState, setModalState] = useState({ modalIsOpen: false });

  const toggleModal = () => {
    setModalState({ modalIsOpen: !modalState.modalIsOpen });
  };
  const DisplayPhotos = ({ item }) => {
    return (
      <div>
        <ImageComponent
          src={item.message}
          alt="TeacherImages"
          onClick={toggleModal}
          style={{ width: "150px", height: "150px" }}
          profile={false}
        />

        <ModalGateway>
          {modalState.modalIsOpen ? (
            <Modal onClose={toggleModal}>
              <Carousel
                components={{ Footer: "" }}
                views={[
                  {
                    src: item.message,
                    width: 2,
                    height: 2,
                    thumbnail: item.thumb,
                  },
                ]}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
    );
  };

  let msg = item.message?.replace(/\\(["'])/g, "$1");

  return (
    <div>
      {item.who !== "teacher" && (
        <StyledDiv1>
          <StyledDiv2>
            {item.message}
            <span className="absolute bottom-[-22px] right-2 xl:text-[10px]">
              {item.time}
            </span>
          </StyledDiv2>
        </StyledDiv1>
      )}
      {item.who === "teacher" && (
        <StyledDiv3>
          {item.type === "Image" ? (
            <StyledDiv5>
              <div className="">
                <DisplayPhotos item={item} />
                <span className="absolute bottom-[-22px] right-1 text-nowrap text-xs xl:text-[10px] xl:right-0 ">
                  {" "}
                  {item.time}
                </span>
              </div>
            </StyledDiv5>
          ) : (
            <StyledDiv4>
              {item.type !== "Image" && msg}
              <span className="absolute bottom-[-22px] right-1 text-nowrap text-xs xl:text-[10px] xl:right-0 ">
                {" "}
                {item.time}
              </span>
            </StyledDiv4>
          )}
        </StyledDiv3>
      )}
    </div>
  );
};

export default Item;
